import { Tour, TOUR_WEEKDAYS } from "../types"

type TourWeekdayStripType = {
    tour: Tour
    compact?: boolean
}

export default function TourWeekdayStrip(props: TourWeekdayStripType) {
    return (
        <div className={`grid grid-cols-5 ${props.compact ? "gap-1 min-w-[14rem]" : "gap-1"}`}>
            {TOUR_WEEKDAYS.map((day) => {
                const count = props.tour.stops.filter((stop) => stop.weekday === day.value).length
                return (
                    <div
                        key={day.value}
                        className={`flex flex-col items-center rounded-md ${props.compact ? "py-0.5 px-1" : "py-1"} ${
                            count > 0 ? "bg-primary/10" : "bg-gray-50 text-gray-300"
                        }`}>
                        <span className="text-[10px] uppercase font-semibold tracking-wide">{day.short}</span>
                        <span className={`text-sm font-semibold leading-tight ${count > 0 ? "text-primary" : ""}`}>{count}</span>
                    </div>
                )
            })}
        </div>
    )
}
